import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import RegistrationPage from './pages/RegistrationPage';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import RegistrationsPage from './pages/RegistrationsPage';
import CheckInPage from './pages/CheckInPage';
import GenerateTicketPage from './pages/GenerateTicketPage';
import SettingsPage from './pages/SettingsPage';
import EmailBroadcastPage from './pages/EmailBroadcastPage';
import './App.css';

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<RegistrationPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/registrations" element={<RegistrationsPage />} />
        <Route path="/admin/checkin" element={<CheckInPage />} />
        <Route path="/admin/generate-ticket" element={<GenerateTicketPage />} />
        <Route path="/admin/settings" element={<SettingsPage />} />
        <Route path="/admin/broadcasts" element={<EmailBroadcastPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
